exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-filter-dropdown .option-row {\n  padding: 2px 10px;\n}\n.table-filter-dropdown .divider {\n  margin-top: 5px;\n  margin-bottom: 1px;\n}\n.table-filter-dropdown .button-row {\n  padding: 5px;\n}\n.table-filter-dropdown .button-row .button-col {\n  display: flex;\n  justify-content: center;\n}\n", ""]);

// exports
